<template>
  <Modal
    :id="'cmp-contacts_contacts_advanced_search'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('contacts_adnvaced_search')}}</template>

    <template slot="body">
      <div class="form-group">
        <div row wrap class="search-row">
          <div class="search--input"></div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'name'"
              v-bind="textFieldConfig"
              v-model="name"
              :placeholder="$dft.capHead( $t('name'))"
            />
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'city'"
              v-bind="textFieldConfig"
              v-model="city"
              :placeholder="$dft.capHead($t('city'))"
            />
          </div>
          <div class="search--checkbox omit">
            <div
              class="omit-toggler"
              :class="{
                omitted: omittedSearches.has('city'),
              }"
              @click="(e) => onSearchOmittedToggle('city')"
            >
              <div class="dt-icon-container">
                <img
                  :src="
                    omittedSearches.has('city')
                      ? 'static/icons/omit-error.svg'
                      : 'static/icons/omit.svg'
                  "
                  class="dt-icon s1 v7"
                  alt="Omit"
                  title="Omit"
                />
              </div>
              <label class="omit-toggler--label">{{ $t('omit') }}</label>
            </div>
            <!-- <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'city'"
                :id="'city'"
                :checked="omittedSearches.has('city')"
                @click="(e) => onSearchOmitted('city', e)"
              />
              <div class="checkmark"></div>
            </div> -->
          </div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <Dropdown
              class="dt-dropdown"
              :options="countriesTV"
              :selected="
                countriesTV.find((c) => c.value == country)
              "
              box
              :placeholder="$t('country')"
              v-on:selectedChange="
                (e) => onDropdownChange('country', e)
              "
              :listHeight="150"
            ></Dropdown>
          </div>
          <div class="search--checkbox omit">
            <div
              class="omit-toggler"
              :class="{
                omitted: omittedSearches.has('country'),
              }"
              @click="(e) => onSearchOmittedToggle('country')"
            >
              <div class="dt-icon-container">
                <img
                  :src="
                    omittedSearches.has('country')
                      ? 'static/icons/omit-error.svg'
                      : 'static/icons/omit.svg'
                  "
                  class="dt-icon s1 v7"
                  alt="Omit"
                  title="Omit"
                />
              </div>
              <label class="omit-toggler--label">{{ $t('omit') }}</label>
            </div>
          </div>
          <!-- <div class="search--checkbox omit">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'country'"
                :id="'country'"
                :checked="omittedSearches.has('country')"
                @click="(e) => onSearchOmitted('country', e)"
              />
              <div class="checkmark"></div>
            </div>
          </div> -->
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'postalcode'"
              v-bind="textFieldConfig"
              v-model="postalcode"
              :placeholder="$t('postalcode')"
            />
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'address'"
              v-bind="textFieldConfig"
              v-model="address"
              :placeholder="$t('address')"
            />
          </div>
          <div class="search--checkbox omit"></div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'region'"
              v-bind="textFieldConfig"
              v-model="region"
              :placeholder="$t('region')"
            />
          </div>
          <div class="search--checkbox omit">
            <div
              class="omit-toggler"
              :class="{
                omitted: omittedSearches.has('region'),
              }"
              @click="(e) => onSearchOmittedToggle('region')"
            >
              <div class="dt-icon-container">
                <img
                  :src="
                    omittedSearches.has('region')
                      ? 'static/icons/omit-error.svg'
                      : 'static/icons/omit.svg'
                  "
                  class="dt-icon s1 v7"
                  alt="Omit"
                  title="Omit"
                />
              </div>
              <label class="omit-toggler--label">{{ $t('omit') }}</label>
            </div>
          </div>
          <!-- <div class="search--checkbox omit">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'region'"
                :id="'region'"
                :checked="omittedSearches.has('region')"
                @click="(e) => onSearchOmitted('region', e)"
              />
              <div class="checkmark"></div>
            </div>
          </div> -->
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <TextField
              :id="'email'"
              v-bind="textFieldConfig"
              v-model="email"
              :placeholder="$t('email')"
            />
          </div>
          <div class="search--checkbox omit">
            <!-- <div class="dt-checkbox v2">
                <input type="checkbox" 
                :name="'email'" 
                :id="'email'" 
                :checked="activatedSearches.has('email')"
                @click="e => onSearchActivated('email', e)"
              >
                <div class="checkmark"
                ></div>
            </div>-->
          </div>
        </div>
        <div row wrap class="search-row">
          <div class="search--input">
            <Dropdown
              class="dt-dropdown"
              :options="groupsTV"
              :selected="
                groupsTV.find((e) => e.value == group_id)
              "
              box
              :placeholder="$t('group')"
              v-on:selectedChange="
                (e) => onDropdownChange('group_id', e)
              "
              :listHeight="150"
            ></Dropdown>
          </div>
          <div class="search--checkbox omit">
            <div
              class="omit-toggler"
              :class="{
                omitted: omittedSearches.has('group_id'),
              }"
              @click="(e) => onSearchOmittedToggle('group_id')"
            >
              <div class="dt-icon-container">
                <img
                  :src="
                    omittedSearches.has('group_id')
                      ? 'static/icons/omit-error.svg'
                      : 'static/icons/omit.svg'
                  "
                  class="dt-icon s1 v7"
                  alt="Omit"
                  title="Omit"
                />
              </div>
              <label class="omit-toggler--label">{{ $t('omit') }}</label>
            </div>
          </div>
          <!-- <div class="search--checkbox omit">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'group_id'"
                :id="'group_id'"
                :checked="omittedSearches.has('group_id')"
                @click="(e) => onSearchOmitted('group_id', e)"
              />
              <div class="checkmark"></div>
            </div>
          </div> -->
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_venue')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'is_venue'"
                :id="'is_venue'"
                :checked="activatedSearches.has('is_venue')"
                @click.stop="(e) => toggleSearch('is_venue', e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">{{ $t('is_a_venue') }}</div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_promoter')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'v'"
                :id="'is_promoter'"
                :checked="activatedSearches.has('is_promoter')"
                @click.stop="
                  (e) => toggleSearch('is_promoter', e)
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">{{$t('is_a_promoter')}}</div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_distr_account')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'is_distr_account'"
                :id="'is_distr_account'"
                :checked="
                  activatedSearches.has('is_distr_account')
                "
                @click.stop="
                  (e) => toggleSearch('is_distr_account', e)
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">
              {{ $t('is_a_distribution_account') }}
            </div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_roy_account')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'is_roy_account'"
                :id="'is_roy_account'"
                :checked="
                  activatedSearches.has('is_roy_account')
                "
                @click.stop="
                  (e) => toggleSearch('is_roy_account', e)
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">
              Is a Royalty Account
            </div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_lic_account')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'is_lic_account'"
                :id="'is_lic_account'"
                :checked="
                  activatedSearches.has('is_lic_account')
                "
                @click.stop="
                  (e) => toggleSearch('is_lic_account', e)
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">
              {{ $t('is_a_royalty_account') }}
            </div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div row wrap class="search-row chbx-row">
          <div
            class="search--input-c"
            @click="(e) => toggleSearch('is_promo_account')"
          >
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'is_promo_account'"
                :id="'is_promo_account'"
                :checked="
                  activatedSearches.has('is_promo_account')
                "
                @click.stop="
                  (e) => toggleSearch('is_promo_account', e)
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label">
              {{ $t('is_a_promotion_account') }}
            </div>
          </div>
          <div class="search--checkbox"></div>
        </div>
        <div
          @click="onExport"
          class="search-row--button dt-button v2"
        >
          <div class="dt-button--icon">
            <div class="dt-icon-container">
              <img
                src="static/icons/export.svg"
                class="dt-icon s1 v7"
                alt="Export Search Result"
                title="Export Search Result"
              />
            </div>
          </div>
          <div class="dt-button--text">
            {{ $t('export_search_result') }}
          </div>
        </div>
        <!-- <div class="search-row">
          <div class="search--input-c" @click="e => toggleSearch('is_promo_account')"></div>
        </div> -->
      </div>
    </template>

    <template slot="options">
      <button
        class="dt-button  with-ico s6"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onCreateGroup"
      >
        <div class="dt-icon-container">
          <img
            src="static/icons/plus.svg"
            class="dt-icon v7"
            alt
          />
        </div>
        <div class="button-text">
          {{ $t("create_group") }}
        </div>
      </button>
      <!-- <button class="dt-button s1" @click.stop="onExport">Export</button> -->
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t('cancel') }}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onDisplayClick"
      >
        {{ $t('apply') }}
      </button>
      <!-- <button class="dt-button s1" @click.stop="onCancel">Close</button> -->
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";

import { addRemoveSet } from "../../../../utility";
import {
  ensureStringObject,
  keyValuesToObj,
} from "../../../../utility/fp";
import Modal from "../../../../dt-plugins/modal/modal";
import { toPairs } from "ramda";

export default {
  components: {
    Modal,
  },
  props: {
    countriesTV: {
      required: true,
      default: () => [],
    },
    groupsTV: {
      required: true,
      default: () => [],
    },
    searchConfig: {
      required: true,
      type: Object,
      default: () => {},
    },
  },
  watch: {
    searchConfig: {
      immediate: true,
      handler: function (to, from) {
        if (!to) {
          return;
        }

        console.log("to", to);

        this.name = to.name;
        this.city = to.city;
        this.postalcode = to.postalcode;
        this.address = to.address;
        this.region = to.region;
        this.email = to.email;
        this.country = to.country;
        this.group_id = to.group_id;

        this.omittedSearches = new Set(
          toPairs(to)
            .filter(([key, value]) => {
              if (isADVSearchOmit(key) && value) {
                return true;
              }
            })
            .map(([key, value]) =>
              findADVSearchKeyFromOmit(key)
            )
        );

        this.activatedSearches = new Set(
          Object.keys(to).filter((k) => {
            if (ActivatedSearchKeys.includes(k) && to[k]) {
              return true;
            }
          })
        );

        console.log(this.omittedSearches);
      },
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },

      name: "",
      city: "",
      postalcode: "",
      address: "",
      region: "",
      email: "",
      country: "",
      group_id: "",

      validationResult: {},

      activatedSearches: new Set(),
      omittedSearches: new Set(),
    };
  },
  mounted: function () {},
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every(
        (e) => e.valid
      );
    },
  },
  methods: {
    onTextFieldValueChange: function (key, value) {
      this.person[key] = value;
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      console.log(name, value);
      this[name] = value.value;
    },
    addNewContact: function (e) {
      this.$emit("new_contact", this.person);
    },
    onSearchActivated: function (name, event) {
      console.log(event.target, this.activatedSearches);
      this.activatedSearches = addRemoveSet(
        event.target.checked,
        this.activatedSearches,
        name
      );
      console.log(
        Array.from(this.activatedSearches),
        event.target.checked
      );

      event.stopPropagation();
      event.preventDefault();
    },
    toggleSearch: function (name) {
      this.activatedSearches = addRemoveSet(
        "toggle",
        this.activatedSearches,
        name
      );
      console.log(Array.from(this.activatedSearches));
      // console.log(this.activatedSearches);
    },
    onSearchOmitted: function (name, event) {
      this.omittedSearches = addRemoveSet(
        event.target.checked,
        this.omittedSearches,
        name
      );
    },
    onSearchOmittedToggle: function (name) {
      const isExistent = this.omittedSearches.has(name);
      this.omittedSearches = addRemoveSet(
        !isExistent,
        this.omittedSearches,
        name
      );
    },
    onDisplayClick: function () {
      const searchConfig = this.createSearchConfig();
      this.$emit("search", searchConfig);
    },
    onExport: function () {
      const searchConfig = this.createSearchConfig();
      this.$emit("export", searchConfig);
    },
    onCreateGroup: function () {
      const searchConfig = this.createSearchConfig();
      this.$emit("create_group", searchConfig);
    },
    createSearchConfig: function () {
      const omittedSearches = keyValuesToObj(
        Array.from(this.omittedSearches).map((om) => [
          om === "group_id" ? `group_omit_id` : `${om}_omit`,
          this[om],
        ])
      );

      const activeSearches = keyValuesToObj(
        Array.from(this.activatedSearches).map((e) => [e, 1])
      );

      return {
        ...ensureStringObject({
          name: this.name,
          city: this.city,
          country: this.country,
          postalcode: this.postalcode,
          address: this.address,
          region: this.region,
          email: this.email,
          group_id: this.group_id,
        }),
        ...omittedSearches,
        ...activeSearches,
      };
    },

    // MARK: Methods
  },
};

export const AdvancedSearchConfigOmitKeyMap = [
  ["name", "name_omit"],
  ["city", "city_omit"],
  ["country", "country_omit"],
  ["postalcode", "postalcode_omit"],
  ["address", "address_omit"],
  ["region", "region_omit"],
  ["email", "email_omit"],
  ["group_id", "group_omit_id"],
];

export const SearchActivatedSearchKeyLabelMap = {
  is_venue: "Is Venue",
  is_promoter: "Is Promoter",
  is_distr_account: "Is Distribution Account",
  is_roy_account: "Is Royalty Account",
  is_lic_account: "Is License Account",
  is_promo_account: "Is Promotion Account",
};

export const ActivatedSearchKeys = Object.keys(
  SearchActivatedSearchKeyLabelMap
);

export const isActivatedSearchKey = (key) =>
  ActivatedSearchKeys.includes(key);

export const AdvancedSearchConfigKeys = [
  ...AdvancedSearchConfigOmitKeyMap.map((e) => e[0]),
  ...ActivatedSearchKeys,
];

export const findADVSearchOmitFromKey = (key) => {
  return AdvancedSearchConfigOmitKeyMap.find(
    (e) => e[0] == key
  )?.[1];
};
export const findADVSearchKeyFromOmit = (omit) => {
  return AdvancedSearchConfigOmitKeyMap.find(
    (e) => e[1] == omit
  )?.[0];
};

export const isADVSearchOmit = (key) => {
  return AdvancedSearchConfigOmitKeyMap.find(
    (e) => e[1] == key
  );
};
</script>

<style lang="scss" scoped>
// .dt-modal {
//   padding: 40px 50px;
//   .dt-modal--options {
//     margin-top: 20px;
//   }
// }

.form-group {
  display: flex;
  flex-direction: column;

  .dt-input-box--container {
    flex: 1;
    --tf-margin: 5px 0px;
  }

  .group-input {
    margin-top: 25px;
    margin-bottom: 10px;
    margin-right: 5px;
  }

  .search-row {
    display: flex;
    &.chbx-row {
      .search--input-c {
        padding: 0px 5px;
      }
    }
    .search--input {
      flex: 1;
      max-width: 394px;
    }
    .search--checkbox {
      min-width: 20px;

      // padding-top: 15px;
      margin-left: 4px;

      display: flex;
      flex-direction: column;
      justify-content: center;

      .omit-toggler {
        display: flex;
        cursor: pointer;
        color:#c0bfbf;
        &.omitted {
          color: var(--c-error);
        }

        .omit-toggler--label {
          margin: auto 0px auto 4px;
          cursor: pointer;
          
        }
      }

      @media screen and (min-width: 320px) and (max-width: 480px) {
        padding-left: 0px;
        margin-left: 0px;

        .checkmark {
          margin-left: 10px;
        }
      }
    }
    .search--input-c {
      cursor: pointer;
      padding: 10px 5px;
      margin: 5px 0px;

      display: flex;
      .dt-checkbox {
        margin-top: 2px;
        margin-right: 10px;
        // flex: 0.8;
      }
      .checkbox-label {
        flex: 11;
      }
    }
  }

  .search-row--button {
    display: flex;
    width: 100%;
    .dt-button--icon {
      // flex: 0.8;
      .dt-icon-container {
        margin-left: 0px;
        margin-right: 5px;
      }
    }
    .dt-button--text {
      flex: 11;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

// .dt-modal--options {
//   button {
//     height: 30px;
//   }
// }
</style>
